export default __webpack_public_path__ + "static/media/call-action-bg.1b92307e.png";